module.exports = __webpack_public_path__ + "static/media/received_407817773334281.8cfb3b2a.jpg";